module.exports = function getResource(label, vars = []) {
    const resources = {
        userImage: 'user generated image',
        postedIn: 'Posted in:',
        remove: 'Remove',
        areYouSure: 'Are you sure you want to delete this look? Once deleted your look and all details will be permanently removed.',
        delete: 'Delete',
        cancel: 'Cancel',
        lookDeleted: 'This look has been successfully deleted. Please allow one hour for the look to be removed.'
    };
    return resources[label];
};
